import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/header-img.svg";
import { ArrowDownCircle } from "react-bootstrap-icons";
import "animate.css";
import TrackVisibility from "react-on-screen";
import resume from "../assets/Arnab-Das-Resume.pdf"

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);
  const toRotate = ["Web Developer", "Web Designer", "UI/UX Design"];
  const period = 2000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => {
      clearInterval(ticker);
    };
  }, [text]);

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta((prevDelta) => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex((prevIndex) => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex((prevIndex) => prevIndex + 1);
    }
  };

  const resumeopenHandler = (e) => {
    e.preventDefault();
    const links = [
      "https://drive.google.com/file/d/1GmhCgxCUo2ppB3NP_u0WaxgDXQJDYuYP/view?usp=sharing",
      "https://drive.google.com/u/0/uc?id=1GmhCgxCUo2ppB3NP_u0WaxgDXQJDYuYP&export=download",
    ];

    window.open(links[1], "_blank");
  };
  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <span className="tagline">🙋‍♂️ Hey! What's up</span>
                  <h1>
                    {`Welcome, I'm Arnab`} <br />{" "}
                    <span
                      style={{ color: "yellow" }}
                      className="txt-rotate"
                      dataPeriod="1000"
                      data-rotate='[ "Web Developer", "Web Designer", "UI/UX Designer" ]'
                    >
                      <span className="wrap">{text}</span>
                    </span>
                  </h1>
                  <p>
                    Always wondered how web applications worked, especially in
                    my childhood when INTERNET was a new thing. Fortunate enough
                    to get the oppurtunity to learn, design and develop web
                    applications. Just enjoying!
                  </p>
                  <a
                    href={resume}
                    download="Arnab-Das-Resume.pdf"
                    onClick={() => {
                      window.open("https://drive.google.com/file/d/1GmhCgxCUo2ppB3NP_u0WaxgDXQJDYuYP/view?usp=sharing", "_blank");
                    }}
                    style={{ textDecoration: "none", color: "white" }}>
                    <button
                      style={{
                        backgroundColor: "white",
                        color: "black",
                        padding: "1rem",
                        borderRadius: "20px",
                      }}
                    >
                      Download Resume <ArrowDownCircle size={25} />
                    </button>
                  </a>
                </div>
              )}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            {/* <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={headerImg} alt="Header Img"/>
                </div>}
            </TrackVisibility> */}
          </Col>
        </Row>
      </Container>
    </section>
  );
};
